import { render, staticRenderFns } from "./RadiationTherapy.vue?vue&type=template&id=f58c1ef0&"
import script from "./RadiationTherapy.vue?vue&type=script&lang=js&"
export * from "./RadiationTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports